export default __webpack_public_path__ + "static/sicum-footer-ecd49b05ad6156de0b7d7144a483e746.jpg";